import { render, staticRenderFns } from "./ChatRoomList.vue?vue&type=template&id=5a422689&scoped=true"
import script from "./ChatRoomList.vue?vue&type=script&lang=js"
export * from "./ChatRoomList.vue?vue&type=script&lang=js"
import style0 from "./ChatRoomList.vue?vue&type=style&index=0&id=5a422689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a422689",
  null
  
)

export default component.exports